// extracted by mini-css-extract-plugin
export default {"subtitleHolder":"EnrGwa","subtitleNewBrandingStyles":"SGZhP2"};